import { Check, ArrowDown } from "lucide-react";
import { MaskedLines, Overline, Reveal, Section } from "./ui";
import ProblemBlock from "./ProblemBlock";

const pains = [
  "Aparece um horário livre e você perde parte dele decidindo o que fazer.",
  "Sua agenda enfraquece e sua primeira reação é pensar em promoção.",
  "Clientes somem e ninguém lembra de chamar novamente.",
  "Você trabalha o dia inteiro e ainda sente que algo importante ficou para trás.",
];

export default function Pains() {
  return (
    <>
      <Section id="dores" tone="black">
        <div className="text-center">
          <Overline>Reconhece a cena?</Overline>
          <MaskedLines
            inView
            as="h2"
            className="mx-auto mt-5 font-serif text-3xl font-medium leading-[1.15] tracking-tight sm:text-4xl lg:text-5xl"
            lines={["Isso é pra você se:"]}
          />
        </div>
        <div className="mx-auto mt-14 max-w-2xl">
          <ul className="divide-y divide-white/10 border-y border-white/10">
            {pains.map((p, i) => (
              <Reveal key={i} delay={i * 0.08} y={20}>
                <li data-testid={`pain-item-${i}`} className="flex items-start gap-4 py-6">
                  <span className="mt-1 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-mom-vinho to-mom-carmim text-white">
                    <Check className="h-3.5 w-3.5" />
                  </span>
                  <p className="font-serif text-lg font-normal leading-snug text-white sm:text-xl">
                    {p}
                  </p>
                </li>
              </Reveal>
            ))}
          </ul>
          <Reveal delay={0.2} className="mt-8 text-center">
            <p className="inline-flex items-center gap-2 rounded-full border border-mom-carmim/40 bg-mom-carmim/10 px-4 py-2 font-dmsans text-xs font-semibold text-mom-carmim">
              Se respondeu sim para 3 ou mais, continue lendo
              <ArrowDown className="h-3.5 w-3.5" />
            </p>
          </Reveal>
        </div>
      </Section>

      <Section tone="white">
        <div className="grid grid-cols-1 items-center gap-14 lg:grid-cols-2">
          <div>
            <Overline>Operação na memória</Overline>
            <MaskedLines
              inView
              as="h2"
              className="mt-5 font-serif text-3xl font-medium leading-[1.15] tracking-tight text-hc-ink sm:text-4xl lg:text-5xl"
              lines={["O salão funciona", "dentro da sua cabeça"]}
            />
            <Reveal delay={0.15} className="mt-8 space-y-5 font-dmsans text-sm leading-relaxed text-hc-mutedInk sm:text-base">
              <p>
                Você atende, responde WhatsApp, olha a agenda, resolve problemas e
                tenta lembrar quem precisava voltar. Um horário abre e surge outra
                decisão:{" "}
                <em className="font-serif text-lg italic text-hc-ink">
                  “O que merece minha atenção agora?”
                </em>
              </p>
              <p>
                Isso é a Operação na Memória. O salão funciona porque alguém tenta
                lembrar de tudo.
              </p>
            </Reveal>
          </div>
          <Reveal delay={0.2} className="rounded-3xl bg-white p-8 shadow-[0_20px_60px_rgba(0,0,0,0.06)] sm:p-10">
            <div className="space-y-4 font-serif text-lg font-medium text-hc-ink sm:text-xl">
              <p>Planner registra tarefa.</p>
              <p>Lista acumula tarefa.</p>
              <p>Agenda mostra horário.</p>
            </div>
            <p className="mt-6 border-t border-dashed border-black/15 pt-6 font-dmsans text-sm leading-relaxed text-hc-mutedInk">
              Nenhum deles escolhe qual ação merece seus próximos 15 minutos. E
              trabalhar muito também não garante avanço: esforço sem direção só
              torna o cansaço mais eficiente.
            </p>
          </Reveal>
        </div>
      </Section>

      <ProblemBlock />
    </>
  );
}
